import { Component, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ApiService } from "src/app/services/api.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CommonEnums } from "src/app/utils/enum-utils";
import { Otp, TransferOwnershipDto } from "src/app/model/qModel.model";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { CommonService } from "src/app/services/common.service";

declare let $: any;

@Component({
  selector: "app-manage-user",
  templateUrl: "./manage-user.component.html",
})
export class ManageUserComponent implements OnInit {
  submitOTPDto: Otp = new Otp();
  isVerified: boolean = false;
  emailErrorMessage: any
  timer: any;
  durationSeconds: any;
  forgotPasswordErrorMessage: string;
  durationMinutes: any;
  timeOver: boolean = true;
  isSentOTP: boolean = false;
  emailResponseOTP: any;
  otpValue: any;
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  @ViewChild("testInput") testInput: any;
  showAddUserPopup: string = 'NO';
  isLoading: boolean = false;
  isOwnership: boolean = false;
  isTransferOwnershipSuccess: boolean = false;
  loggedInUser: any;
  addUserErrorMessage: any;
  transferDto: TransferOwnershipDto = new TransferOwnershipDto();
  deviceiD: any
  getUserDeviceData: any
  getTransferOwnershipUser: any;
  selectedLanguage: any
  userResponse: any[] = [];
  selectedIndex: number = 0;
  getFirstIndexData: any;
  enableGridView: boolean = false;
  isGridView: boolean = true;
  isTreeView: boolean = false;
  s3Url: any;
  noDeviceFount: boolean = false;
  deleteUserResponseMessage: any;
  getAssignedUserStatus: any;
  deleteSuccess: boolean = false;
  emailSentUserName: any;
  language: any;
  modalForEng: boolean = false;
  show: boolean = false;
  activeUsers: any;
  pendingUsers: any;
  userType: any;
  activeUsersCount: number = 0;
  pendingUsersCount: number = 0;
  privacyStatusBg: String = "#DEE9FE";
  privacyStatusClr: String = "#3F3F3F";
  isupdateUser: boolean = true;
  userData: any;
  isPhoneNoVerified: boolean;
  addUserForm: FormGroup = new FormGroup({
    name: new FormControl(''),
    role: new FormControl(''),
    email: new FormControl(''),
  });

  transferOwnershipForm: FormGroup = new FormGroup({
    assignedUserId: new FormControl(''),

  });
  screenWidth: any;
  screenHeight: any;
  openActiveUsers: boolean = true;
  openSignUpPending: boolean;
  editMode: boolean = false;
  isEmailVerified: any;
  constructor(private _formBuilder: FormBuilder, private _router: Router, private _service: ApiService, private _toastr: ToastrService, private _translate: TranslateService, private _commonService: CommonService) { }

  ngAfterViewInit() {
    this.testInput?.nativeElement?.focus();
    this.selectedIndex = 0;
    this.showAddUserPopup = 'NO';
    if (this.loggedInUser.roleType !== 'ADMIN') {
      this.addUserForm.controls['role'].addValidators(Validators.required);
    }

    setTimeout(() => {
      this.testInput.nativeElement.focus();
    }, 1000);
  }
  ngOnInit(): void {
    this.getAllData();
  }
  getAllData(): void {
    $("#target").val($("#target option:first").val());
    this.enableGridView = true;
    this.deleteUserResponseMessage = null;
    this.screenWidth = window.screen.width;
    this.screenHeight = window.screen.height;
    scrollTo(0, 0);
    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.loggedInUser = JSON.parse(currentUser);
    }

    this.getAllUser();
    this.selectedIndex = 0;
    let selectedLangStringValue = localStorage.getItem('selectedLang');
    if (selectedLangStringValue) {
      this.selectedLanguage = selectedLangStringValue;
      this._translate.use(this.selectedLanguage);
    }
    this.addUserForm = this._formBuilder.group(
      {
        name: ['', [Validators.required]],
        role: [''],
        email: ['', [Validators.required, Validators.email, Validators.pattern('^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$')]],
      },

    );
    this.transferOwnership();
    this.showAddUserPopup = 'NO';

    this.language = localStorage.getItem('selectedLang');
    if (!this.language || this.language == 'en' || this.language == '') {
      this.modalForEng = false;
    } else {
      this.modalForEng = true;
    }
  }

  // Get Enums
  public get CommonEnum(): typeof CommonEnums {
    return CommonEnums;
  }

  //  Checking if all the mandatory fields has been added to the Input or selection box
  closeModaltransfer() {
    this.individualChecked = false;
    this.allChecked = false;
    $("#transferOwnerShipAfterConfirmation").modal("hide");
    this.transferOwnershipForm.controls['assignedUserId'].setValue(null);
  }
  transferOwnership() {
    this.transferOwnershipForm = this._formBuilder.group(
      {
        assignedUserId: ['', [Validators.required]],
      },
    );
  }

  // Fetching the Added User here and Displaying in the grid view
  getAllUser() {
    try {
      this.isLoading = true;
      this._service.getService(this._service.API_URL.getAllUsers).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.userResponse = response.data;
          this.isLoading = false;
          this.activeUsers = this.userResponse.filter(userResponse => userResponse.assignedUserStatus === 'ASSIGNED_USER_STATUS_ASSIGNED');
          this.activeUsersCount = this.activeUsers.length;
          this.pendingUsers = this.userResponse.filter(userResponse => userResponse.assignedUserStatus === 'ASSIGNED_USER_STATUS_PENDING');
          this.pendingUsersCount = this.pendingUsers.length;
          this.userResponse.forEach((element: any) => {
            if (element.avatarUrl) {
              this.getDownloadPreSignedurl(element)
            }
          });
          if (this.activeUsers && this.selectedIndex == 0 && this.openActiveUsers) {
            this.getFirstIndexData = this.activeUsers[0];
            this.isPhoneNoVerified = this.getFirstIndexData.mobileNoVerified;
          }
          else if (this.pendingUsers && this.selectedIndex == 0 && this.openSignUpPending) {
            this.getFirstIndexData = this.pendingUsers[0];
          }
        }
      })
    } catch (error) {

    }
  }

  //  To Display the Image for the User we are Downloading the presigned Url and Here and Assigning to the Image Tag
  getDownloadPreSignedurl(element: any) {
    try {
      this._service.getService(this._service.API_URL.getDownloadPreSignedurl + "?objectKey=" + element.avatarUrl).subscribe((response) => {
        if (response && response.status.code === 200) {
          element.avatarUrl = response.data.avatarUrl;
        }
      })
    } catch (error) {

    }
  }

  //  Closing Add User Modal(Popup) here
  closeAddUserModal() {
    $('#addUserPopup').modal('hide');
    this.addUserForm.controls['email'].setValue(null);
    this.addUserForm.controls['name'].setValue(null);
    this.addUserForm.controls['role'].setValue('');
    this.addUserErrorMessage = null;
  }


  // Displaying the Date based on Selecting of Grid view or List view
  openGridOrTreeView(viewType: any) {
    if (viewType === 'grid') {
      this.enableGridView = true;
      this.isGridView = true;
      this.isTreeView = false;
    } else {
      this.enableGridView = false;
      this.isGridView = false;
      this.isTreeView = true;
    }
  }


  //  Checking if User has any device Before Deleting that user and Show and Hide Modal based on Data True and False
  checkUserBeforeDeleting(data: any) {
    try {
      this._service.getService(this._service.API_URL.checkUserBeforeDeleting + '/' + data.id).subscribe((response) => {
        if (response && response.status.code === 200) {
          if (response.data === false) {
            this.noDeviceFount = true;
            this.deleteSuccess = false;
            this.deleteUserResponseMessage = null;
            $('#deleteUserPopup').modal('show');
          } else {
            $('#transferOwnerShipBefore').modal('show');
            this.transferOwnershipForm.controls['assignedUserId'].setValue(undefined);
          }
        } else {
          this._toastr.error('', response.status.message)
        }
      })
    } catch (error) {

    }
  }

  // Opening Temp User Delete Popup

  openTempUserDeletePopup(data: any) {
    this.deleteSuccess = false;
    this.getAssignedUserStatus = data.assignedUserStatus;
    if (data) {
      this.noDeviceFount = true;
      $('#deleteUserPopup').modal('show');
    }
  }
  // Closing the Transfer Ownership Modal befor and Openign the Transfer Ownership modal afert the confirmaton for the transfer ownership

  openTransferOwnershipModal() {
    $('#transferOwnerShipBefore').modal('hide');
    this.isOwnership = false;
    this._commonService.setUserData(this.getFirstIndexData);
    this._router.navigate(['home/change-owner'], { state: { prevPage: this._router.url } });
    // setTimeout(() => {
    //   $('#transferOwnerShipAfterConfirmation').modal('show');
    //   this.isOwnership = true;
    //   this.gettransferownershipuser();
    //   this.getDeviceByUserId();
    // }, 100);
  }


  // Get User By UserId

  getDeviceByUserId() {
    this._service.getService(this._service.API_URL.getDeviceByUserId + '/' + this.getFirstIndexData.id).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.getUserDeviceData = response.data.myDeviceList;
        if (this.getUserDeviceData?.length === 1) {
          this.individualChecked = true;
          this.allChecked = true;
          this.deviceIdList.add(this.getUserDeviceData[0].id)
        } else {
          this.individualChecked = false;
          this.allChecked = false;
        }
      }
    })
  }

  deviceIdList = new Set();
  individualChecked: boolean = false;
  allChecked: boolean = false;
  //  Fetching the Device Id here and Passing the data to the TransferOwnership for Transfer Ownership
  onDeviceClick(event: any, data: any, type: string) {
    if (type == 'single') {
      if (event.target.checked && !this.allChecked) {
        this.deviceIdList.add(data.id);
        this.allChecked = this.getUserDeviceData?.length == this.deviceIdList.size;
      }
      else {
        this.allChecked = false
        this.deviceIdList.delete(data.id)
        this.individualChecked = this.deviceIdList.size > 0

      }
    }
    else {
      if (event.target.checked) {
        data.forEach((element: any) => {
          this.allChecked = true
          this.individualChecked = true
          this.deviceIdList.add(element.id);
        })
      }
      else {
        data.forEach((element: any) => {
          this.individualChecked = false
          this.allChecked = false
          this.deviceIdList.delete(element.id);
        })
      }
    }
  }

  getUser: any
  transferOwnershipUsername(evt: any) {
    this.getTransferOwnershipUser?.forEach((element?: any) => {
      if (element.id === evt) {
        this.getUser = element.name;
      }
    });
    if (evt == this.loggedInUser.id) {
      this.getUser = this.loggedInUser.name
    }
  }


  //  Transfer Ownership To Assigned User
  onTransferOwnership() {
    try {
      this.transferDto.currentUserId = this.getFirstIndexData.id;
      this.transferDto.deviceIdList = Array.from(this.deviceIdList);
      this.transferDto.assignedUserId = this.transferOwnershipForm.controls['assignedUserId'].value;
      this._service.putService(this._service.API_URL.manageDeviceTransferOwnership, this.transferDto).subscribe((response: any) => {
        if (response.status.code === 200) {
          this.deviceIdList = new Set();
          this.isOwnership = false;
          this.isTransferOwnershipSuccess = true;
          this.getDeviceByUserId();
          this.getAllUser();
        }
        else {
          this._toastr.error('', response.status.message);
        }
      })
    } catch (error) {
      console.log(error);

    }
  }

  //  Closing Transfer Ownrship Modal (Popup) here
  closeTransferSuccess() {
    $('#transferOwnerShipAfterConfirmation').modal('hide');
    this.isTransferOwnershipSuccess = false;
  }

  //  Delete User Logic is here

  tempUser: boolean = false;
  deleteAssignedUser(data: any) {
    try {
      if (this.getAssignedUserStatus === 'ASSIGNED_USER_STATUS_PENDING') {
        this.tempUser = true;
      } else {
        this.tempUser = false;
      }
      this._service.deleteService(this._service.API_URL.deleteAssignedUser + '/' + data.id + '?isTempUser=' + this.tempUser).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.deleteSuccess = true;
          this.noDeviceFount = false;
          this.deleteUserResponseMessage = response.status.message;
          this.selectedIndex = -1;
          this.getFirstIndexData = this.userResponse[0]
        } else {
          this._toastr.error('', response.status.message)

          $('#deleteUserPopup').modal('hide');
        }

        this.getAllData();
      })
    } catch (error) {

    }
  }

  // Openign the Add User Modal Here
  openAddUser() {
    this._router.navigate(['home/add-user']);
    // this.addUserForm.reset();
    // this.isVerified = false;
    // this.otpValue = null;
    // this.emailResponseOTP = null;
    // this.timeOver = false;
    // this.isSentOTP = false;
    // this.forgotPasswordErrorMessage = '';

    // if (this.loggedInUser.roleType === 'ADMIN') {
    //   this.addUserForm.get('role')?.setValidators(null)
    // }
    // this.addUserErrorMessage = null;
    // this.showAddUserPopup = 'NO';
    // $('#addUserPopup').modal('show');
    // setTimeout(() => {
    //   this.testInput.nativeElement.focus();
    // }, 0);

    // this.ngAfterViewInit()
  }

  // Closing the Invite Succes Modal based on Invite type whether Reshare or Add User
  closeInviteModal(type: any) {
    if (type === 'addUserInvite') {
      $('#addUserPopup').modal('hide');
    } else {
      $('#reshareLinkModal').modal('hide');
    }

  }

  // Closeing Invite Succefully Modal(Popup)
  closeSuccessPopup() {
    this.deleteSuccess = false;
    this.noDeviceFount = false;
    $('#deleteUserPopup').modal('hide');
    this.getAllUser();
  }

  //  On Click on Perticular user Fetching the data here
  getPerUserData(index: any, data: any) {
    this.isPhoneNoVerified = data.mobileNoVerified;
    this.isEmailVerified = data.emailVerified;
    if (this.screenWidth > 576) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    this.getFirstIndexData = data;
    this.selectedIndex = index;
    this.editMode = false;
    if (data.assignedUserStatus != '') {
      return 'pending-active'
    } else {
      return 'no-activepending'
    }
  }

  //  Checking If form has be Entered and Enabling the Submit User button
  addUser() {
    this.addUserForm = this._formBuilder.group(
      {
        name: ['', [Validators.required]],
        role: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email, Validators.pattern("^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,3}(?:\\.[A-Za-z]{2,3})?)$")]],
      },
    );
  }
  get f(): { [key: string]: AbstractControl } {
    return this.addUserForm.controls;
  }
  isNavigate(val: string, id: any) {
    if (val == 'viewDevice' && id === this.loggedInUser.id) {
      this._router.navigate(['home/manage-device'])
    }
    else if (val == 'viewDevice') {
      this._router.navigate(['home/manage-device', id]);
    } else {
      this._router.navigate(['home/license-summary', id]);
    }
  }
  isNavigateMyDeviceOrLicense(val: string, id: any) {
    if (val == 'viewDevice' && id === this.loggedInUser.id) {
      this._router.navigate(['home/manage-device'])
    }
    else if (val == 'viewDevice') {
      this._router.navigate(['home/manage-device', id]);
    }
    if (val == 'viewLicense' && id === this.loggedInUser.id) {
      this._router.navigate(['home/license-summary']);
    } else {
      this._router.navigate(['home/license-summary', id]);
    }
  }
  //  To Add the User Logic has been implemented here
  onAddUser(event: MouseEvent) {
    try {

      (event.target as HTMLButtonElement).disabled = true;
      if (this.addUserForm.controls['email'].value) {
        this.emailSentUserName = this.addUserForm.controls['email'].value
        this.addUserErrorMessage = null;
        this._service.postService(this._service.API_URL.addUser, this.addUserForm.value).subscribe((response: any) => {
          if (response && response.status.code === 200) {
            $('#addUserPopup').modal('show');
            if (this.addUserForm.controls['role'].value == CommonEnums.CHILD) {

              this.showAddUserPopup = 'CHILD';
            } else {
              this.showAddUserPopup = 'YES';
            }
            this.getAllUser();
            this.addUserForm.controls['email'].setValue(null);
            this.addUserForm.controls['role'].setValue('');
            this.addUserForm.controls['name'].setValue(null);
            this.addUserErrorMessage = response.status.message;
          } else if (response && response.status.code === 400) {
            this._toastr.error('', response.status.message);

            (event.target as HTMLButtonElement).disabled = false;
          }
        })
      }
    } catch (error) {

    }
  }

  //  If User is in Pending status and wants to Reshare the link to Signup. Reshare Link Logic is here
  reshareLink(user: any) {
    try {
      let data = {
        name: user.name,
        role: user.roleType,
        email: user.email,
        id: user.id,
        mobileNo: user.mobileNo,
        lastName: user.lastName,
        isMobileNoVerified: user.mobileNoVerified
      }
      this.emailSentUserName = user.email;
      this._service.postService(this._service.API_URL.addUser, data).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          $("#reshareLinkModal").modal("show");
          this.getAllUser();
          this.addUserForm.reset();
          this.addUserErrorMessage = null;
        } else if (response && response.status.code === 400) {
          this._toastr.error('', response.status.message)
        }
        else {
          this.addUserErrorMessage = response.status.message;
        }

      })
    } catch (error) {

    }
  }



  //  Fetching all the user For Assigning to the Transfer Ownership Modal(Popup)
  gettransferownershipuser() {
    try {
      this._service.getService(this._service.API_URL.gettransferownershipuser).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.getTransferOwnershipUser = response.data;
        }
      })
    } catch (error) {

    }
  }

  trackByFn(item: any) {
    return item.id;
  }
  keyPressAlphaNumericWithCharacters(event: any, name: any) {
    if (name == 'email') {
      if (event.target.selectionStart === 0) {
        let k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
      }
    } else
      if (event.target.selectionStart === 0) {
        let k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
      } else if (name == 'name') {
        let inp = String.fromCharCode(event.keyCode);
        // Allow numbers, alpahbets, space, underscore
        if (/[a-zA-Z0-9-_ ]/.test(inp)) {
          return true;
        } else {
          event.preventDefault();
          return false;
        }
      }
  }
  removeSpace(event: any, name: any) {
    if (name == 'email') {
      if (event.code === "Space") {
        event.preventDefault()

      }
    } else {
      if (event.target.selectionStart === 0 && event.code === "Space") {
        event.preventDefault()

      }
    }
  }

  onlyAlphabets(event: any) {
    if (event.target.selectionStart === 0) {
      if ((/\d/g).test(event.key)) event.preventDefault();
    }
  }
  // To get OTP for the Add User
  // getting otp value

  onOtpChange(event: any) {
    this.emailErrorMessage = null;
    this.otpValue = event;
  }

  emailOTP() {
    this.forgotPasswordErrorMessage = '';
    try {
      this.emailErrorMessage = null;
      clearInterval(this.timer);

      this.timeOver = true;
      let data = {
        userName: this.addUserForm.controls['email'].value,
        otpType: CommonEnums.SIGNUP
      };
      this._service
        .postService(this._service.API_URL.emailGenerateOtp, data)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.isSentOTP = true;
            this.startTimerForFiveMinute(3);
            this.emailResponseOTP = response.data;
            setTimeout(() => {
              this.ngOtpInputRef.setValue(null);
            }, 0);

          } else {
            this.isSentOTP = false;
            this.emailErrorMessage = response.status.message;
          }
          if (response && response.status.code === 400) {
            this._toastr.error('', response.status.message)
          }
        });
    } catch (e) { }
  }

  //  Start timer for Email Verification
  startTimerForFiveMinute(minute: number) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    this.timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.durationMinutes = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;


      if (seconds == 0) {
        this.timeOver = false;
        clearInterval(this.timer);
      }
    }, 1000);
  }

  // To get OTP for Email Verification  Resend OTP Logic is here
  config = {
    allowNumbersOnly: true,
    length: 4,
  };

  verifyOtp() {
    if (this.otpValue?.length == 4) {
      this.submitOTPDto.otpChar = this.emailResponseOTP;
      this.submitOTPDto.otpType = CommonEnums.SIGNUP;
      this.submitOTPDto.otpNo = this.otpValue
      this._service
        .postService(
          this._service.API_URL.signupOtpVerification,
          this.submitOTPDto
        )
        .subscribe((response: any) => {
          if (response.status.code === 200) {

            this.timeOver = true;
            this.isVerified = true;

          } else {
            this.isVerified = false;
            this.forgotPasswordErrorMessage = response.status.message;
          }
        });
    }
  }
  verifyAgain(d: any) {
    this.isVerified = false;
    this.otpValue = null;
    this.emailResponseOTP = null;
    this.timeOver = false;
    this.isSentOTP = false;
    this.forgotPasswordErrorMessage = '';
    if (d == 'role')
      this.addUserForm.reset();
  }
  //  On this Click we are opening the tabs (My Device) Or (Users Device)
  openTabs(data: any) {
    this.userType = data;
    this.editMode = false;
    if (this.userType === 'ACTIVEUSERS') {
      this.openActiveUsers = true;
      this.openSignUpPending = false;
    } else {
      this.openActiveUsers = false;
      this.openSignUpPending = true;
    }
    this.selectedIndex = 0;
    if (this.activeUsers && this.selectedIndex == 0 && this.openActiveUsers) {
      this.getFirstIndexData = this.activeUsers[0];
    }
    else if (this.pendingUsers && this.selectedIndex == 0 && this.openSignUpPending) {
      this.getFirstIndexData = this.pendingUsers[0];
    }
  }
  enableEdit(data: any) {
    if (data === 'editMode') {
      this.editMode = true;
    }
    else {
      this.editMode = false;
    }
  }
  disableEdit() {
    this.editMode = false;
    this.ngOnInit();
  }
  roleMap: { [key: string]: string } = {
    'Super Admin': 'MANAGEUSER.SUPERADMIN',
    'Admin': 'MANAGEUSER.ADMIN',
    'Member': 'MANAGEUSER.MEMBER',
    'Child': 'MANAGEUSER.CHILD'
  };

  getRoleLabel(roleStr: string): string {
    const key = this.roleMap[roleStr];
    return key ? this._translate.instant(key) : roleStr;
  }

}
